import { streamService } from "@/features/chat/services/streamService";
import { useChatContext } from "stream-chat-react";

/**
 * Returns a function that opens (or creates) a 1:1 DM channel with the given
 * user ID and sets it as the active channel.
 */
export function useStartDirectChat() {
  const { client, setActiveChannel } = useChatContext();

  return async (targetUserId: string) => {
    if (!client?.userID) return;
    try {
      const channelId = await streamService.createChannel([targetUserId]);
      const channel = client.channel("messaging", channelId);
      await channel.watch();
      setActiveChannel(channel);
    } catch (error: any) {
      console.error("Failed to start direct chat:", error?.message || error);
    }
  };
}
